export const BRAND_REVIEW_STATUS = {
  PENDING: 'Pending',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
};

export const REVIEW_STATUS_TEXT = {
  [BRAND_REVIEW_STATUS.PENDING]: _TL_('Pending editorial review'),
  [BRAND_REVIEW_STATUS.REJECTED]: _TL_('Disapproved'),
  [BRAND_REVIEW_STATUS.APPROVED]: _TL_('Eligible'),
};
